"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import type { Transition } from "motion/react";
import { motion } from "motion/react";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import { useAccordionItem } from "../provider";
import type { AccordionContentProps } from "../types";

const DEFAULT_TRANSITION: Transition = {
  type: "spring",
  stiffness: 150,
  damping: 22,
};

function AccordionContent({
  transition = DEFAULT_TRANSITION,
  className,
  children,
  ...props
}: AccordionContentProps) {
  const { isOpen } = useAccordionItem();

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <AccordionPrimitive.Content forceMount {...native}>
      <motion.div
        key="accordion-content"
        data-slot="accordion-content"
        initial={{ height: 0, opacity: 0, "--mask-stop": "0%" }}
        animate={
          isOpen
            ? { height: "auto", opacity: 1, "--mask-stop": "100%" }
            : { height: 0, opacity: 0, "--mask-stop": "0%" }
        }
        exit={{ height: 0, opacity: 0, "--mask-stop": "0%" }}
        transition={transition}
        style={{
          maskImage:
            "linear-gradient(black var(--mask-stop), transparent var(--mask-stop))",
          WebkitMaskImage:
            "linear-gradient(black var(--mask-stop), transparent var(--mask-stop))",
        }}
        className={cn("bg-muted overflow-hidden")}
        {...props}
      >
        <div className={cn("p-4", className, classes)}>{children}</div>
      </motion.div>
    </AccordionPrimitive.Content>
  );
}

AccordionContent.displayName = "Accordion.Content";

export default AccordionContent;
